;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _vueTableDynamic = require("vue-table-dynamic");

var _vueTableDynamic2 = _interopRequireDefault(_vueTableDynamic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "RevShare",
  props: ["dbrevshares"],
  data: function data() {
    return {
      item: null,
      value: null,
      desc: null,
      indexes: [],
      topushData: [],
      selectedIndex: null,
      revshares: [],
      final_revshare: null,
      params: {
        data: null,
        header: "row",
        showCheck: true,
        border: true,
        edit: {
          column: [1, 2],
          cell: [[-1, -1]]
        }
      }
    };
  },

  components: { VueTableDynamic: _vueTableDynamic2.default },
  mounted: function mounted() {
    var _this = this;

    this.params.data = [["Index", "Business Item", "Business Item Value"]];
    $("#addRevShare").on("hidden.bs.modal", function () {
      _this.reset();
    });

    var parsed = JSON.parse(this.dbrevshares);
    if (parsed != null) {
      parsed.forEach(function (part, index, theArray) {
        var item = theArray[index].item;
        var value = theArray[index].value;
        _this.params.data.push([index + 1, item, value]);
        _this.topushData.push({
          item: item,
          value: value
        });
      });
    }
  },

  methods: {
    reset: function reset() {
      this.item = null;
      this.value = null;
      this.desc = null;
    },
    add_row: function add_row() {
      $("#addRevShare .close").click();
      var i = this.params.data.length - 1;
      this.params.data.push([i + 1, this.item, this.value]);

      this.topushData.push({
        item: this.item,
        value: this.value
      });

      this.final_revshare = (0, _stringify2.default)(this.topushData);
      this.reset_revshare(this.final_revshare);
    },
    remove_row: function remove_row() {
      this.params.data.splice(this.selectedIndex, 1);
      this.topushData.$remove(this.topushData[this.selectedIndex - 1]);
      this.final_revshare = (0, _stringify2.default)(this.topushData);
      this.reset_revshare(this.final_revshare);
      this.selectedIndex = null;
    },
    onSelect: function onSelect(isChecked, index, data) {
      if (isChecked) {
        this.indexes.push(index);
        this.selectedIndex = index;
      } else {
        this.indexes.$remove(index);
        this.selectedIndex = null;
      }
    },
    onSelectionChange: function onSelectionChange(checkedDatas, checkedIndexs, checkedNum) {},
    onCellChange: function onCellChange(rowIndex, columnIndex, data) {
      if (columnIndex == 2) {
        this.topushData[rowIndex - 1].value = data;
      } else {
        this.topushData[rowIndex - 1].account_number = data;
      }
      this.final_revshare = (0, _stringify2.default)(this.topushData);
      this.reset_revshare(this.final_revshare);
    },

    reset_revshare: function reset_revshare(val) {
      $("#revshares").val(val);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-demo",staticStyle:{"width":"100%"}},[_vm._m(0),_vm._v(" "),(_vm.selectedIndex)?_c('a',{staticClass:"btn",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.remove_row}},[_c('i',{staticClass:"fa fa-remove"})]):_vm._e(),_vm._v(" "),_c('vue-table-dynamic',{ref:"table",attrs:{"params":_vm.params},on:{"select":_vm.onSelect,"selection-change":_vm.onSelectionChange,"cell-change":_vm.onCellChange}}),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"addRevShare","tabindex":"-1","role":"dialog","aria-labelledby":"addRevShare","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',{attrs:{"onsubmit":"return false;"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Business Item")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item),expression:"item"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.item)},on:{"input":function($event){if($event.target.composing){ return; }_vm.item=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Business Item Value")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Add Item"},on:{"click":_vm.add_row}})])])])])])],1)}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn",attrs:{"href":"javascript:void(0)","data-toggle":"modal","data-target":"#addRevShare"}},[_c('i',{staticClass:"fa fa-plus"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Add Business Details")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-063d4ca8", __vue__options__)
  } else {
    hotAPI.reload("data-v-063d4ca8", __vue__options__)
  }
})()}